import { AsyncPipe, DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { RouterLink } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'
import { BehaviorSubject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'

import { UserAccessComponent } from '~/core/components'
import { DestroyDirective } from '~/core/directives'
import { EForecastRisk, EGuardEntityName, EGuardSectionName, IForecastDto } from '~/core/models'
import { ForecastCompanySize, ForecastNumber } from '~/shared/pipes'

@Component({
  selector: 'app-company-header-card',
  templateUrl: './company-header-card.component.html',
  styleUrl: './company-header-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [
    DatePipe,
    AsyncPipe,
    RouterLink,
    MatIconModule,
    ForecastNumber,
    TranslateModule,
    MatButtonModule,
    MatDividerModule,
    UserAccessComponent,
    ForecastCompanySize,
  ],
})
export class CompanyHeaderCardComponent implements OnInit {
  @Input() showHomePageLink = false
  @Input() guardSectionName: EGuardSectionName | null | undefined
  @Input() set forecast(forecast: IForecastDto | null | undefined) {
    if (forecast) {
      this.forecast$.next(forecast)
    }
  }

  EGuardEntityName = EGuardEntityName
  EForecastRisk = EForecastRisk
  announceDate = new Date()
  readonly forecast$ = new BehaviorSubject<IForecastDto | null>(null)

  private readonly destroy$ = inject(DestroyDirective).destroy$

  ngOnInit(): void {
    this.forecast$
      .pipe(
        filter(f => Boolean(f)),
        takeUntil(this.destroy$)
      )
      .subscribe(forecast => {
        if (forecast!.announceDays < -1 && forecast!.qrtrEndDate) {
          this.announceDate = new Date(forecast!.qrtrEndDate)
          this.announceDate = new Date(this.announceDate.getFullYear(), this.announceDate.getMonth() + 4, 0)
        }
      })
  }
}
